'use client';

import { c as _c } from "react/compiler-runtime";
import { Header as HeaderComponent } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import type { LinkItemData } from 'node_modules/design-system/src/lib/pageParts/shared/types';
import { type ReactNode, useMemo } from 'react';
import TextLink from '@/components/TextLink';
import { RailsRoutes } from '@/helpers/utils';
function Header(t0) {
  const $ = _c(45);
  const {
    children
  } = t0;
  const locale = useLocale();
  const t = useTranslations("nextjs.header");
  let t1;
  if ($[0] !== locale) {
    t1 = RailsRoutes.homePageSearch({
      locale
    });
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const searchUrl = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("links.discover");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== locale) {
    t3 = RailsRoutes.discovery({
      locale
    });
    $[4] = locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      children: t2,
      href: t3,
      prefetch: false
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("links.collect");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== locale) {
    t6 = RailsRoutes.collect({
      locale
    });
    $[11] = locale;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = {
      children: t5,
      href: t6,
      prefetch: false
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("links.aboutUs");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== locale) {
    t9 = RailsRoutes.aboutUs({
      locale
    });
    $[18] = locale;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = {
      children: t8,
      href: t9,
      prefetch: false
    };
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t4 || $[25] !== t7) {
    t11 = [t4, t7, t10];
    $[23] = t10;
    $[24] = t4;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const links = t11;
  let t12;
  if ($[27] !== t) {
    t12 = t("betterplace_logo_alt_text");
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("claim");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t("search.placeholder");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t) {
    t15 = t("search.placeholder");
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== links || $[36] !== searchUrl || $[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t15) {
    t16 = {
      logoAlt: t12,
      claim: t13,
      homePageUrl: process.env.NEXT_PUBLIC_BETTERPLACE_URL,
      searchUrl,
      searchLabel: t14,
      searchPlaceholder: t15,
      links
    };
    $[35] = links;
    $[36] = searchUrl;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== children || $[43] !== t16) {
    t17 = <HeaderComponent text={t16} Link={TextLink}>{children}</HeaderComponent>;
    $[42] = children;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  return t17;
}
export default Header;